<template>
  <div class="row">
    <div
      class="col-xs-12 explanation"
    >
      {{ trans('subscription.subscribable_groupings.check_explanation') }}
    </div>

    <div class="col-xs-12">
      <template v-if="isLoading">
        <div class="loading">
          <span class="fa fa-2x fa-spinner fa-spin" />
        </div>
      </template>

      <template v-else>
        <template
          v-for="subcribableObject in value.subscribableNames"
        >
          <div :key="subcribableObject.id">
            <input
              :id="'checkbox_' + subcribableObject.id"
              type="checkbox"
              :value="subcribableObject.id"
              :checked="allSelected(subcribableObject.id)"
              @click="selectAll(subcribableObject.id)"
            >
            <label
              class="capitalize"
              :for="'checkbox_' + subcribableObject.id"
            >{{ subcribableObject.name }}</label>

            <div
              v-for="subscribable in subscribablesByIdentifier(subcribableObject.id)"
              :id="'checkbox_' + subcribableObject.id"
              :key="subscribable.id"
              class="subscribable-name"
            >
              <input
                :id="'checkbox_' + subscribable.id"
                v-model="selectedSubscribableIds"
                type="checkbox"
                :value="subscribable.id"
              >
              <label
                :for="'checkbox_' + subscribable.identifier"
                class="subscribable-label"
              >
                {{ subscribableInfo(subscribable) }}
              </label>
            </div>
          </div>
          <br>
        </template>
      </template>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { orderBy, pluck } from 'lodash'
import toast from '@/services/toast'
import { GROUP } from '@/constants'
import { defaultErrorMessage } from '@/helpers'

export default {
  name: 'CheckComponent',

  props: {
    value: {
      required: true,
      type: Object,
    },
  },

  data () {
    return {
      isLoading: true,
      subscribables: {},
      typeGroup: GROUP,
    }
  },
  computed: {

    selectedSubscribableIds: {
      get () {
        return this.value.selectedSubscribableIds
      },
      set (value) {
        this.$emit('input', { ...this.value, selectedSubscribableIds: value })
        this.setSubscribablesInStoreForRules(value)
        if (this.value.hasSubscribables === 'empty') {
          this.$emit('canFinishStep')
        } else if (value != null && value.length > 0) {
          this.$emit('canFinishStep')
        } else {
          this.$emit('canNotFinishStep')
        }
      },
    },
  },

  created () {
    const value = this.value
    value.names = this.value.subscribableNames.map(obj => obj.id)

    axios.post('/employee/subscribable-groupings/create/subscribables/api', { ...value }).then((response) => {
      this.subscribables = response.data.data

      const newSubscribableIds = Object.values(this.subscribables).map(subscribable => subscribable.id)
      if (this.selectedSubscribableIds.length > 0) {
        this.selectedSubscribableIds = this.selectedSubscribableIds.filter((id) => {
          return newSubscribableIds.includes(String(id))
        })
      } else {
        this.selectedSubscribableIds = newSubscribableIds
      }
    }).catch(error => defaultErrorMessage(error))
      .finally(() => {
        this.isLoading = false
      })
  },

  methods: {
    allSelected (name) {
      const allSubscribableIds = this.subscribablesByIdentifier(name).map(subscribable => subscribable.id)
      let checked = true

      allSubscribableIds.forEach(id => {
        if (!this.selectedSubscribableIds.includes(id)) {
          checked = false
          return checked
        }
      })

      return checked
    },

    selectAll (name) {
      const allSubscribableIds = this.subscribablesByIdentifier(name).map(subscribable => subscribable.id)
      const allSelected = this.allSelected(name)

      if (allSelected) {
        this.selectedSubscribableIds = this.selectedSubscribableIds.filter(id => {
          return !allSubscribableIds.includes(id)
        })
      } else {
        let newIds = []

        allSubscribableIds.forEach(id => {
          if (!this.selectedSubscribableIds.includes(id)) {
            newIds = newIds.concat(id)
          }
        })

        this.selectedSubscribableIds = this.selectedSubscribableIds.concat(newIds)
      }
    },

    subscribablesByIdentifier (id) {
      const subscribables = Object.values(this.subscribables).filter(subscribable => subscribable.attributes.name.toLowerCase() === id.toLowerCase())

      return this.value.subscribablesType == this.typeGroup ? subscribables : _.orderBy(subscribables, 'attributes.eventStarttime')
    },

    subscribableInfo (subscribable) {
      return subscribable.attributes.extraInfo + ', ' + Lang.get('subscription.groups') + ': ' + subscribable.attributes.studentGroups
    },
    setSubscribablesInStoreForRules (subscribableIds) {
      const subscribables = {}
      for (let i = 0; i < subscribableIds.length; i++) {
        subscribables[subscribableIds[i]] = this.getSubscribableNameWithId(subscribableIds[i])
      }
      this.$store.dispatch('set_rule_subscribables', subscribables)
      this.$store.dispatch('set_selector_subscribables', subscribables)
    },
    getSubscribableNameWithId (id) {
      const subscribableNameWithId = Object.values(this.subscribables).find(subscribable => subscribable.id === id)
      if (subscribableNameWithId) {
        return this.subscribableInfo(subscribableNameWithId)
      }
      return 'Name not found'
    },
  },
}
</script>

<style>
    .capitalize {
        text-transform: capitalize;
    }

    .explanation {
        margin-bottom: 20px;
    }

    .subscribable-label {
        font-weight: normal !important;
    }

    .subscribable-name {
        margin-left: 20px;
    }

    .loading {
        text-align: center;
    }
</style>
